import React from "react";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { add_wtf_benefits, update_wtf_benefits } from "../../data/ApiEndpoints";
import { wtfBenefitsSchema } from "../../schema/schema";
import { Form } from "react-bootstrap";
import { commonPostPutFormData } from "../../redux/reducers/commonApiSlice";

const WtfBenefitsForm = ({
  getBenefitsData,
  isEdit,
  closeModal,
  initialValues,
  token,
}) => {
  const dispatch = useDispatch();

  console.log("initialValues => ", initialValues);

  const formik = useFormik({
    initialValues: initialValues || {
      name: "",
      image: null,
      status: "active",
    },
    validationSchema: wtfBenefitsSchema,
    onSubmit: async (values) => {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit ? update_wtf_benefits : add_wtf_benefits;

      const formData = new FormData();

      formData.append("status", values?.status);

      if (isEdit && initialValues) {
        formData.append("name", values?.name);
      } else {
        formData.append("name", [JSON.stringify(values?.name)]);
      }

      if (values.image) {
        formData.append("image", values.image);
      }

      if (isEdit && initialValues) {
        formData.append("uid", initialValues?.uid);
      }

      const result = await dispatch(
        commonPostPutFormData({
          method: method,
          endpoint: endpoint,
          token: token,
          requestBody: formData,
        })
      );

      console.log("result => ", result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        getBenefitsData();
      } else {
        toast.error(result?.payload?.message || "Failed!");
      }
    },
  });

  const onChangeInput = (e) => {
    const { name, checked } = e.target;
    formik.setFieldValue(name, checked ? "active" : "inactive");
  };

  console.log("formik => ", formik.values);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={isEdit ? "Edit Facility" : "Add Facility"}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Save"}
        onClose={closeModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid oneGridSystem">
          <div className="formInputBox">
            <label>
              Enter Name
              <span className="text-danger">*</span>
            </label>
            <div className="commonWrapper dropdownCommonWrapper">
              <input
                type="text"
                name="name"
                // className=""
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "10px",
                  fontWeight: "500",
                }}
                placeholder="Enter Name"
                value={formik.values.name || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.name && formik.errors.name ? (
              <div className="error-message">{formik.errors.name}</div>
            ) : null}
          </div>
        </div>

        <div
          className=""
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: "1rem",
            // background: "#f2f2f2",
            width: "100%",
          }}
        >
          <div>
            <label
              style={{
                paddingBottom: "10px",
              }}
            >
              Select Image<span className="text-danger">*</span>
            </label>
            <div>
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={(event) => {
                  const file = event.currentTarget.files?.[0] || null;
                  formik.setFieldValue("image", file);
                }}
                // style={{
                //   display: isEdit ? " none " : "block",
                // }}
              />
              {formik.touched.image && formik.errors.image ? (
                <div className="error-message">{formik.errors.image}</div>
              ) : null}
            </div>
          </div>
          {formik?.values?.image && (
            <div className="formInputBox">
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                Preview
              </label>
              <div className="selectedImages_Wrapper">
                <div className="selectedImages">
                  <img
                    // src={formik?.values?.image}
                    src={
                      typeof formik.values.image === "string"
                        ? formik.values.image // Use directly if it's a URL
                        : URL.createObjectURL(formik.values.image) // Convert if it's a file
                    }
                    alt={`Preview`}
                    style={{
                      width: "70px",
                      height: "70px",
                      objectFit: "cover",
                    }}
                  />
                  <button
                    type="button"
                    className="remove-image-btn"
                    onClick={() => {
                      formik.setFieldValue("image", null);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      className="bi bi-x"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="formInputBox formInputSwitchBox">
          {/* <label>Status</label> */}
          <div className={`commonWrapper commonSwitchWrapper no-border`}>
            <Form.Check
              type="switch"
              name="status"
              label={formik?.values?.status}
              checked={formik.values.status === "active"}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default WtfBenefitsForm;
